<div>
    <div class="strength-meter">
        <div
            class="strength-meter-fill"
            [style.background]="getMeterFillColor(passwordStrength)"
            [attr.data-strength]="passwordStrength"
        ></div>
    </div>
    <ng-container *ngIf="enableFeedback && feedback">
        <div class="mb-2 ms-2" *ngIf="feedback.warning">
            {{ feedback.warning }}
            <div *ngFor="let suggetion of feedback.suggestions">{{ suggetion }}</div>
        </div>
    </ng-container>
</div>
